export var CommercialFeatureFlags;
(function (CommercialFeatureFlags) {
    CommercialFeatureFlags["Embedding"] = "embedding";
    CommercialFeatureFlags["Scim"] = "scim-token-management";
    CommercialFeatureFlags["AiCopilot"] = "ai-copilot";
    CommercialFeatureFlags["ServiceAccounts"] = "service-accounts";
    CommercialFeatureFlags["OrganizationWarehouseCredentials"] = "organization-warehouse-credentials";
    CommercialFeatureFlags["CustomRoles"] = "custom-roles";
})(CommercialFeatureFlags || (CommercialFeatureFlags = {}));
//# sourceMappingURL=commercialFeatureFlags.js.map